<app-auth-layout>
  <div class="action-token-container">
    @if (isProcessing) {
    <div class="loading-spinner">
      <p><strong>{{ actionTokenComponent()?.processingTokenMessage }}</strong></p>
    </div>
    }
  </div>
</app-auth-layout>
